import { Component, Inject, PLATFORM_ID, HostListener, Output, EventEmitter } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FuncionService } from './servicios/funcion.service';
import { User, Base64 } from './utilidades/utilidades';
import { Observable, throwError, BehaviorSubject, Subject } from 'rxjs';
import { Router, NavigationEnd, Params, NavigationStart, RoutesRecognized } from '@angular/router';

import { environment } from '../environments/environment.prod';

import { filter, pairwise } from 'rxjs/operators';

// import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
// import { Keepalive } from '@ng-idle/keepalive';
import { UserIdleService } from 'angular-user-idle';

import * as $ from 'jquery';

declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [
        trigger('tgMenu',[
            state('close',style({
                left:'-100%'
            })),
            state('open',style({
                left:'0%'
            })),
            transition('close => open',animate(250)),
            transition('open => close',animate(250))
        ])
    ]
})
export class AppComponent {

    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    title = 'angular-idle-timeout';
    newParams:Params = {};

    showMenuUser:boolean = false;
    newUser:User;
    stateMenu:string = "close";
    conSugerencias:boolean = false;
    showMenuCategorias:boolean = false;
    listaCategorias:any[] = [];
    showLoader:boolean = false;
    newMensaje:string = "";
    showAlerta:boolean = false;
    newAlerta:any = null;
    correoElectronico:string = "";
    txtBusqueda:string = "";
    listaSugerencias:any = [];
    @Output() newEmit = new EventEmitter();


    previousUrl = new BehaviorSubject<string>(null);
    currentUrl = new BehaviorSubject<string>(null);

    @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        if (isPlatformBrowser(this.platformId)){
            if( $(event.target).scrollTop() === 0 ){
                $(event.target).find('.menu').css({position:"relative"});
            }else{
                $(event.target).find('.menu').css({position:"fixed"});
            }
        }
    }

    @HostListener('window:click', ['$event'])
    onClick(event) {
        if (isPlatformBrowser(this.platformId)){
            var validacion = false;
            var newPath = [];
            if(event.path){
                newPath = event.path;
            }else{
                var newParents = $(event.target).parents();
                for(var i=0; i<=newParents.length;i++){
                    newPath.push(newParents[i]);
                }
            }
            newPath.forEach( (newItem)=>{
                if(newItem){
                    if( newItem.classList ){
                        newItem.classList.forEach( (newClass)=>{
                            if( newClass === "sugerencias"){
                                validacion = true;
                            }
                        });
                    }
                }
            });
            if( !validacion ){
                this.conSugerencias = false;
            }
        }
    }

    fnShowModal(){
        if (isPlatformBrowser(this.platformId)){
            $('#modal-container').removeAttr('class').addClass("one");
            $('body').addClass('modal-active');
        }
    }

    fnHideModal(){
        this.newFuncionService.fnUpdateToken();
        if (isPlatformBrowser(this.platformId)){
            $('#modal-container').addClass('out');
            $('body').removeClass('modal-active');
        }
        this.userIdle.resetTimer();
    }

    reset() {
        // this.idle.watch();
        this.timedOut = false;
    }


    constructor( 
        private newFuncionService:FuncionService, 
        @Inject(PLATFORM_ID) private platformId: Object,
        private newRouter:Router,
        private userIdle: UserIdleService/*,
        private idle: Idle, 
        private keepalive: Keepalive*/
        ){
    }
     
    ngOnInit(): void {
        this.setUpAnalytics();


        this.newRouter.events.pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
        .subscribe((events: RoutesRecognized[]) => {
            let urlPrevia = events[0].urlAfterRedirects;
            let urlActual = events[1].urlAfterRedirects;
            if( urlPrevia && urlActual ){
                this.newFuncionService.fnNavegacion({
                    uuid:this.newFuncionService.currentUuidValue,
                    urlFrom:urlPrevia,
                    urlTo:urlActual
                }).subscribe( (response:any)=>{})
            }
        });


        this.newFuncionService.usuarioSesion().subscribe( (newUser:User)=>{
            this.newUser = newUser;
            // console.log(this.newUser.session)
            if( localStorage.getItem('cerrarSesion') === "true" ){
                this.newFuncionService.fnCerrarSesion(this.newUser);
            }else{
                if( this.newUser.session ){
                    if (isPlatformBrowser(this.platformId)){

                        this.userIdle.startWatching();
        
                        this.userIdle.onTimerStart().subscribe(count =>{

                        });
                        
                        this.userIdle.onTimeout().subscribe(() =>{
                            this.timedOut = true;
                            this.fnShowModal();
                        });
                    }
                }else{
                    this.userIdle.stopTimer();
                    this.userIdle.stopWatching();
                }

                this.newFuncionService.fnTotalProductosCarrito({ venta:{ uuid: this.newFuncionService.currentUuidValue } }).subscribe( (response:any) =>{
                    if( response.success ){
                        this.newUser.totalProductos = response.totalProductos;
                    }else{
                        this.newUser.totalProductos = 0;
                    }
                });
            }
        });

        this.newFuncionService.fnRequestPost( environment.peticion.categorias, {} ).subscribe( (response:any)=>{
            if( response.success ){
                this.listaCategorias = response.lista;
                this.newFuncionService.cargarCategorias( this.listaCategorias );
            }
        });

        this.newFuncionService.getNewMensaje().subscribe( (response)=>{
            if( response ){
                this.newMensaje = response;
                this.showLoader = true;
            }else{
                this.showLoader = false;
            }
        });

        this.newFuncionService.getNewAlerta().subscribe( (response)=>{
            if( response ){
                this.newAlerta = response;
                this.showAlerta = true;
                setTimeout( ()=>{
                    this.showAlerta = false;
                }, 5000);
            }else{
                this.showAlerta = false;
            }
        });
    }

    setUpAnalytics() {
        this.newRouter.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.newFuncionService.createLinkForCanonicalURL();
                gtag('config', 'G-9Y5BE4PPS1',
                    {
                        page_path: event.urlAfterRedirects
                    }
                );
            });
    }

    fnAccionMenu( newTipo ){
        if( newTipo ){
            if( this.stateMenu === "open" ){
                this.stateMenu = "close";
            }
        }else{
            this.stateMenu = (this.stateMenu === "close") ? "open" : "close";
        }
    }

    fnAccionCategorias(){
        this.showMenuCategorias = !this.showMenuCategorias;
    }

    fnCloseAlerta(){
        this.showAlerta = false;
    }

    fnSuscribir(){
        if( this.correoElectronico === "" ){
            this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.vacio );
        }else if( !environment.validacion.correo.test( this.correoElectronico ) ){
            this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.formato );
        }else{
            this.newFuncionService.setNewMensaje("Registrando tu correo a nuestro newsletter");
            this.newFuncionService.fnSuscribir({ correo:this.correoElectronico }).subscribe( (response:any) =>{
                this.newFuncionService.setNewMensaje(null);
                if(response.success){
                    this.correoElectronico = "";
                    this.newFuncionService.setNewAlerta( environment.alerta.newsletter.success );
                }else{
                    this.newFuncionService.setNewAlerta( environment.alerta.newsletter.fail );
                }
            })
        }
    }

    fnCerrarSesion(){
        this.fnAccionMenu( false );
        $('#modal-container').addClass('out');
        $('body').removeClass('modal-active');
        this.newFuncionService.fnCerrarSesion( this.newFuncionService.currentUserValue );
    }

    fnBuscarProductos(){
        $(".txtBusqueda").blur();
        this.conSugerencias = false;
        this.newRouter.navigate(["/tienda"], { queryParams: {buscar:this.txtBusqueda} });
        if( this.newRouter.url.match(/tienda/g) ){
            this.newEmit.emit();
        }
    }

    fnLinkCarrito(){
        this.fnAccionMenu( true );
        if( this.newUser.totalProductos > 0 ){
            this.newRouter.navigate(['carrito']);
        }
    }

    fnSeleccionSubcategoria( newCategoria ){
        let newEncoder = new Base64();
        this.newRouter.navigate(["tienda"], { queryParams: {categorias: [`${encodeURI(newEncoder.encode( `${newCategoria.id}` ))}-${newCategoria.alias}`]} });
    }

    fnSeleccionCategoria( newCategoria ){
        this.fnAccionMenu( false );
        let newEncoder = new Base64();
        this.newRouter.navigate(["tienda"], { queryParams: {categorias: [`${encodeURI(newEncoder.encode( `${newCategoria.id}` ))}-${newCategoria.alias}`]} });
        if( this.newRouter.url.match(/tienda/g) ){
            this.newEmit.emit();
        }
    }

    fnBuscarSuguerencias( newEvent ){
        if( newEvent.code === "Enter" ){
            this.txtBusqueda = "";
            this.conSugerencias = false;
        }else{
            if( newEvent.target.value !== "" && newEvent.target.value.length >=2  ){
                this.newFuncionService.fnGetSugerencias({ busqueda:newEvent.target.value }).subscribe( (response:any)=>{
                    if( response.success ){
                        if( response.busqueda === newEvent.target.value ){
                            this.conSugerencias = true;
                            this.listaSugerencias = response.sugerencias;
                        }
                    }else{
                        this.conSugerencias = false;
                    }
                });
            }else{
                this.conSugerencias = false;
            }
        }
    }

    fnIrSugerencia( newSugerencia ){
        this.conSugerencias = false;
        this.txtBusqueda = newSugerencia;
        this.fnBuscarProductos();
    }

    fnIrSugerenciaProducto(newSugerencia){
        this.conSugerencias = false;
        this.newRouter.navigate(["producto", encodeURI(`${newSugerencia.skuProveedor} ${newSugerencia.alias}`)]);
    }

    fnIrSugerenciaCategoria(newSugerencia){
        this.conSugerencias = false;
        let newEncoder = new Base64();
        var lista = [];
        newSugerencia.identificador.filter(this.unique).forEach(function( newItem ){
            lista.push(`${encodeURI(newEncoder.encode( `${newItem.id}` ))}-${newItem.alias}`);
        });
        this.newParams = {categorias:lista};
        this.newRouter.navigate(['tienda'], { queryParams: this.newParams });
    }

    fnIrSugerenciaMarca(newSugerencia){
        this.conSugerencias = false;
        let newEncoder = new Base64();
        this.newParams = {marcas:[`${encodeURI(newEncoder.encode( `${newSugerencia.id}` ))}-${newSugerencia.alias}`]};
        this.newRouter.navigate(['tienda'], { queryParams: this.newParams });
    }

    unique = (value, index, self) => {
        return self.indexOf(value) === index
    }

}
